import { render, staticRenderFns } from "./AscentiHome.vue?vue&type=template&id=352db07d&scoped=true"
import script from "./AscentiHome.vue?vue&type=script&lang=js"
export * from "./AscentiHome.vue?vue&type=script&lang=js"
import style0 from "./AscentiHome.vue?vue&type=style&index=0&id=352db07d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "352db07d",
  null
  
)

export default component.exports